import { useContext } from 'react'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@edvi-tech/ui/dialog'
import Controls from '../Controls/Controls'
import { AuthContext } from '../../Context/AuthContext'

const ApproveTnCDialog = ({ open, close, isTutorFlow }) => {
  const { AcceptTnC } = useContext(AuthContext)

  const handleVerify = async () => {
    await AcceptTnC()
    window.location.reload(false)
    close()
  }

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        className="edvi-dlg-content--sm gap-0 rounded-2xl border-[#eef0f6] p-0"
        showCloseButton={false}
      >
        <DialogHeader className="space-y-1 px-6 pb-4 pt-6 text-center sm:text-center">
          <DialogTitle className="text-xl font-semibold text-[#1c2434]">
            Terms &amp; Conditions Updated!
          </DialogTitle>
        </DialogHeader>

        <div className="edvi-dlg__scroll edvi-tnc-dlg px-6 pb-4">
          <p className="edvi-tnc-dlg__text">
            By accessing or using edvi&apos;s services, website, or mobile
            applications (the &quot;Service&quot;), you acknowledge that you
            have read, understood, and agree to be bound by our{' '}
            <a
              className="edvi-tnc-dlg__link"
              href={
                isTutorFlow
                  ? 'https://policies.edvi.app/tutor/terms'
                  : 'https://policies.edvi.app/terms'
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              {isTutorFlow
                ? 'Terms and Conditions and Privacy Policy.'
                : 'Terms and Conditions'}
            </a>
            {isTutorFlow ? '' : ' and '}
            {isTutorFlow ? null : (
              <a
                className="edvi-tnc-dlg__link"
                href="https://policies.edvi.app/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy.
              </a>
            )}{' '}
            If you do not agree to these terms, you must refrain from using the
            Service.
          </p>
        </div>

        <DialogFooter className="edvi-dlg__actions justify-center border-t border-[#eef0f6] bg-[#fbfbfe] px-6 py-4">
          <Controls.Button text="Accept Now" onClick={handleVerify} />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ApproveTnCDialog
